import { render, staticRenderFns } from "./paper-info-sf.vue?vue&type=template&id=52f4d8be&scoped=true"
import script from "./paper-info-sf.vue?vue&type=script&lang=ts"
export * from "./paper-info-sf.vue?vue&type=script&lang=ts"
import style0 from "./paper-info-sf.vue?vue&type=style&index=0&id=52f4d8be&prod&lang=scss&scoped=true"
import style1 from "./paper-info-sf.vue?vue&type=style&index=1&id=52f4d8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4d8be",
  null
  
)

export default component.exports